import React from 'react'
 
class RepositolyListLoading extends React.Component {
    render() {
        return (
             
                    <div className="box">
                       Loading...
                    </div>
             
              
           
        )
    }
}

export default RepositolyListLoading


// WEBPACK FOOTER //
// ./src/components/RepositolyListLoading.react.js